import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

// Masked slide-up reveal, triggered once when scrolled into view.
export function Reveal({ children, delay = 0, y = 28, ...rest }) {
    const reduce = useReducedMotion();
    return (
        <motion.div
            initial={reduce ? false : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}

// Streams words in one-by-one — LLM-token cadence, not a typewriter.
export function StreamedWords({ words, delay = 0, className, style }) {
    const reduce = useReducedMotion();
    return (
        <span className={className} style={style} aria-label={words.join(' ')}>
            {words.map((word, i) => (
                <motion.span
                    key={i}
                    aria-hidden="true"
                    initial={reduce ? false : { opacity: 0, filter: 'blur(6px)' }}
                    whileInView={{ opacity: 1, filter: 'blur(0px)' }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.45, delay: delay + i * 0.09, ease: 'easeOut' }}
                    style={{ display: 'inline-block', whiteSpace: 'pre' }}
                >
                    {word + (i < words.length - 1 ? ' ' : '')}
                </motion.span>
            ))}
        </span>
    );
}
